import Experience from "./Experience/Experience";
import Cards from "./Experience/Interactions/Cards";
import Lenis from "@studio-freight/lenis";
import cards from "./Experience/cards";

const createdCards = new Cards();
const experience = new Experience({
  targetElement: document.querySelector(".app"),
});

// const lenis = new Lenis();

// lenis.on("scroll", (e) => {});

// function raf(time) {
//   lenis.raf(time);
//   requestAnimationFrame(raf);
// }

// requestAnimationFrame(raf);
